import { SignEnvironment } from '.';

const envProduction: SignEnvironment = {
  domain: 'sign.yabawt.net'
};

export default envProduction;
